import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Switch from "@material-ui/core/Switch";
import WithRowLabel from "./PickupComponents/WithRowLabel";
import { compose } from "recompose";

const styles = (theme) => ({
  root: {
    width : "auto",
    height: 40,
    padding: 0,
    marginBottom:6,
    marginRight: 16,
    display: "flex",
  },
  switchBase: {
    padding: 2,
    color: theme.palette.primary.main,
    "&$checked": {
      transform: "translateX(28px)",
      color: theme.white,
      "& + $track": {
        opacity: 1,
        backgroundColor: theme.palette.primary.main,
        borderColor: theme.palette.primary.main,
      },
      "&$disabled": {
        "& + $track": {
          opacity: 1,
          borderColor: theme.white,
          backgroundColor: theme.iconColor,
          "&:before": {
            color: theme.white,
          },
          "&:after": {
            color: theme.white,
          },
        },
      },
    },
    "&$disabled": {
      "& + $track": {
        opacity: 1,
        borderColor: theme.white,
        backgroundColor: theme.iconColor,
        cursor: "not-allowed",
        "&:before": {
          color: theme.white,
        },
        "&:after": {
          color: theme.white,
        },
      },
    },
  },
  thumb: {
    width: 18,
    height: 18,
    boxShadow: "none",
  },
  track: {
    border: `1px solid ${theme.successTextColor}`,
    borderRadius: 14,
    opacity: 1,
    backgroundColor: "transparent",
    height: 24,
    width: 56,
    left: 28,
    "&:before, &:after": {
      fontSize:theme.textFontSize,
      lineHeight: 2,
    },
    "&:before": {
      content: '"Yes"',
      marginLeft: 8,
      opacity: 0,
      color: theme.white,
    },
    "&:after": {
      content: '"No"',
      marginRight: 4,
      color: theme.successTextColor,
    },
  },
  checked: {
    "& + $track": {
      backgroundColor: theme.palette.primary.main,
      "&:before": {
        opacity: 1,
      },
      "&:after": {
        opacity: 0,
      },
    },
  },
  disabled: {
    "& + $track": {
      opacity: 1,
      borderColor: theme.white,
      backgroundColor: theme.iconColor,
      "&:before": {
        color: theme.white,
      },
      "&:after": {
        color: theme.white,
      },
    },
  },
});


const CustomSwitch = (props) => {
  const { classes } = props;
  return (
    <Switch
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        icon: classes.thumb,
        bar: classes.track,
        checked: classes.checked,
        disabled: classes.disabled,
      }}
      checked={props.value}
      onChange={(event) => props.onChange(event.target.checked)}
      disabled={props.disabled || false}
      onKeyDown={(event) => props.handleKeyDown(event)}
    />
  );
};

export default compose(WithRowLabel, withStyles(styles))(CustomSwitch);
